var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget"},[_c('BaseWidgetTitle',{attrs:{"title":_vm.tokens.widgetMarketWatch.marketWatch},on:{"close":function($event){return _vm.hideModal('market')}}}),_c('SymbolsGroup'),_c('AssetsInfoModal',{on:{"close":function($event){return _vm.hideModal('market')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }